import { useNavigate } from 'react-router-dom'
import { amplTrack } from '@stlm/common-ui/lib'
import { LocationResponse, PointResponse } from '../constants/types'
import { QUERIES, ROUTES } from '../constants/routes'
import { useActions } from './redux/actions'

// const SideBarClosingAnimationDurationMs = 500

export const useSideBarControlls = () => {
  const navigate = useNavigate()
  const {
    setSelectedPoint,
    setSelectedPointId,
    openPointInfo,
    openNewPointForm,
    openNewPoint,
    closeNewPoint,
    closeNewPointForm,
    openEditPointForm,
    closeEditPointForm,

    setSelectedLocation,
    setSelectedLocationId,
    openLocationInfo,

    setSelectedEvent,
    setSelectedEventId,
    setScrollTargetEventId,
    resetScrollTargetEventId,
    openEventInfo,
    openNewEventForm,
    openEditEventForm,
    closeNewEventForm,
    closeEditEventForm,

    closeSideBar,
    startSideBarClosing,
    setSideBarClosingInitiated,
    setInitialEventsOpenState,

    showPointsAndEventsPanel,
  } = useActions()

  const controlls = {
    showEventsPanel: () => {
      setInitialEventsOpenState()
      setSelectedEvent(null)
      setSelectedEventId(null)
    },

    resetEventScroll: () => {
      resetScrollTargetEventId()
    },

    showPointInfo: (point: PointResponse) => {
      // TODO: investigate ability to move history to saparate util with method goHome, addSearchParam etc
      navigate({
        pathname: ROUTES.HOME,
        search: `?${QUERIES.POINT_ID}=${point.id}`,
      })

      setSelectedPoint(point)
      setSelectedPointId(point.id)
      setSelectedLocation(null)
      setSelectedLocationId(null)
      openPointInfo()
    },

    showLocationInfo(location: LocationResponse) {
      navigate({
        pathname: ROUTES.HOME,
        search: `?${QUERIES.LOCATION_ID}=${location.id}`,
      })
      setSelectedLocation(location)
      setSelectedLocationId(location.id)
      setSelectedPoint(null)
      setSelectedPointId(null)
      openLocationInfo()
    },

    showEventInfo(event: any) {
      // navigate({
      //   pathname: ROUTES.HOME,
      //   search: `?${QUERIES.EVENT_ID}=${event.id}`,
      // });
      setSelectedEvent(event)
      setSelectedEventId(event.id)
      setScrollTargetEventId(event.id)
      // setSelectedPoint(null);
      // setSelectedPointId(null);
      openEventInfo()
    },

    showEventEdit(event: any) {
      // navigate({
      //   pathname: ROUTES.HOME,
      //   search: `?${QUERIES.EVENT_ID}=${event.id}`,
      // });
      setSelectedEvent(event)
      setSelectedEventId(event.id)
      // setSelectedPoint(null);
      // setSelectedPointId(null);
      openEditEventForm()
    },

    closeSideBar() {
      navigate(ROUTES.HOME)
      startSideBarClosing()
      setSelectedLocationId(null)
      setSelectedPointId(null)

      // setTimeout(() => {
      setSelectedPoint(null)
      setSelectedEvent(null)
      setSelectedEventId(null)
      setSelectedLocation(null)
      closeSideBar()
      setSideBarClosingInitiated(false)
      // }, SideBarClosingAnimationDurationMs)
    },

    showCreateNewPoint() {
      openNewPointForm()
      amplTrack({ name: 'map_add_place_form_open' })
    },

    showCreateNewEvent() {
      openNewEventForm()
      amplTrack({ name: 'map_add_event_form_open' })
    },

    showNewPoint() {
      openNewPoint()
    },

    closeEditPoint(shouldCloseSideBar: boolean | undefined = false) {
      closeEditPointForm()
      if (shouldCloseSideBar) {
        controlls.closeSideBar()
      } else {
        openPointInfo()
      }
    },

    openEditPoint() {
      openEditPointForm()
    },

    closeCreateNewPoint() {
      closeNewPointForm()
    },

    closeCreateNewEvent() {
      closeNewEventForm()
    },

    closeEditEvent() {
      closeEditEventForm()
    },

    setSideBarClosingInitiated(state: boolean) {
      setSideBarClosingInitiated(state)
    },

    showPointsPanel() {
      showPointsAndEventsPanel()
      navigate(ROUTES.HOME)

      setSelectedLocationId(null)
      setSelectedPointId(null)

      setSelectedPoint(null)
      setSelectedEvent(null)
      setSelectedEventId(null)
      setSelectedLocation(null)
    },
  }

  return controlls
}
